import React from 'react';

const Question = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="m15.641 6.6426c-2.298 0.3449-4.09 2.0456-4.09 4.1464h1.4004c0-1.2921 1.1492-2.4994 2.8965-2.7617 1.7473-0.26233 3.4365 0.57438 4.002 1.8145 0.56542 1.2401 0.02493 2.5914-1.4688 3.3301l0.62109 1.2559c2.0328-1.0054 3.0036-3.2305 2.1211-5.166-0.882-1.9358-3.185-2.9644-5.482-2.6194z" />
    <path
      d="m18.506 13.143s-5.1131 2.7163-5.209 8.6602l1.4004 0.02344c0.08315-5.1527 4.4609-7.4453 4.4609-7.4453l-0.65234-1.2383z"
      fillRule="evenodd"
    />
    <path d="m17.984 3.0117c-0.975-0.152-1.991-0.1541-3.009 0.0117-4.072 0.6632-7.1078 3.8757-7.1078 7.6836h1.4004c2e-7 -3.0624 2.4531-5.7362 5.9316-6.3027 3.4786-0.56652 6.8844 1.1886 8.0957 4.0703s-0.0234 6.0962-3.0371 7.7129l0.66211 1.2344c3.5694-1.9148 5.1576-5.9398 3.666-9.4883-1.1187-2.6614-3.6754-4.4659-6.6016-4.9219z" />
    <g fillRule="evenodd">
      <path d="m20.854 15.854s-3.7686 1.8619-3.8398 5.9844l1.3984 0.02344c0.05659-3.2755 3.0605-4.752 3.0605-4.752l-0.61914-1.2559z" />
      <path d="m13.289 21.299v1.4004h5.1484v-1.4004h-5.1484z" />
      <path d="m7.9023 10.492v1.4004h5.0215v-1.4004h-5.0215z" />
    </g>
    <path d="m13.289 24.029v0.69922 3.5273h5.0801v-4.2266h-5.0801zm1.4004 1.4004h2.2793v1.4277h-2.2793v-1.4277z" />
  </svg>
);

export default Question;
